var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationPin = function SvgLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.106 14.875a30 30 0 0 0 3.512 3.531 30 30 0 0 0 3.512-3.53c1.606-1.912 3.512-4.758 3.512-7.47a6.94 6.94 0 0 0-2.055-4.95A7.04 7.04 0 0 0 4.93.935a7 7 0 0 0-4.336 6.47c0 2.712 1.906 5.558 3.512 7.47m.502-7.469c0-1.657 1.347-3 3.01-3a3.005 3.005 0 0 1 3.01 3c0 1.657-1.347 3-3.01 3a3.005 3.005 0 0 1-3.01-3",
    clipRule: "evenodd"
  })));
};
export default SvgLocationPin;